import { ScheduleAssistReplyResponse } from "../contracts/ScheduleAssistReplyResponse";
import { SchedulePlan } from "../models/SchedulePlan";

export interface AssistantReply {
  reply: string;
  plan: SchedulePlan | null;
}

export class ScheduleAssistReplyResponseMapper {
  toAssistantReply(response: ScheduleAssistReplyResponse): AssistantReply {
    return {
      reply: response.reply,
      plan: response.plan
        ? { summary: response.plan.summary, actions: response.plan.actions }
        : null,
    };
  }
}
